<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <pedido-cuenta-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import PedidoCuentaShowData from "./PedidoCuentaShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "PedidoCuentaShow",
        components: {CrudShow, PedidoCuentaShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'cobrox.pedidoCuenta.showing',
            }
        },
    }
</script>

